import { Button } from '../../../../core/components/atoms/Button';
import { Typography } from '../../../../core/components/molecules/Typography';
import { CardEmpty } from '../CardEmpty';
import { useNavigate } from 'react-router-dom';

export function EmptyFavs() {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col items-center'>
      <div className='flex w-1/2 flex-col items-center gap-xxl'>
        <Typography variant='italic'>
          Você ainda não favoritou nenhum conteúdo.
        </Typography>
        <CardEmpty />
        <CardEmpty />
        <Button
          LeftIcon='house'
          iconVariant='rounded'
          variant='outlined'
          className='w-fit px-8'
          onClick={() => navigate('/')}
        >
          Voltar para Minha Área
        </Button>
      </div>
    </div>
  );
}
